var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 27",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9987 7.77682H19.4244C19.149 7.77682 18.9236 7.54839 18.9236 7.26921C18.9236 6.99002 19.149 6.7616 19.4244 6.7616H24.9987C25.2741 6.7616 25.4995 6.99002 25.4995 7.26921C25.4995 7.54839 25.2741 7.77682 24.9987 7.77682Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3043 21.7359C29.1291 21.7359 28.9538 21.6851 28.8035 21.609L23.4949 18.5633C23.2445 18.411 22.969 18.3603 22.6936 18.3603H8.74585C6.46714 18.3603 4.63916 16.4821 4.63916 14.1979V5.16241C4.63916 2.87816 6.46714 1 8.74585 1H26.1993C28.478 1 30.306 2.87816 30.306 5.16241V20.6953C30.306 21.076 30.1307 21.4059 29.8052 21.5836C29.6549 21.6851 29.4796 21.7359 29.3043 21.7359ZM29.3043 20.7207L29.3294 5.18779C29.3294 3.43653 27.9271 2.01522 26.1993 2.01522H8.74585C7.01803 2.01522 5.64079 3.43653 5.64079 5.16241V14.1979C5.64079 15.9491 7.04308 17.3451 8.74585 17.3451H22.6936C23.1443 17.3451 23.595 17.472 23.9957 17.7004L29.3043 20.7207Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9984 12.3963H14.5313C14.2559 12.3963 14.0305 12.1679 14.0305 11.8887C14.0305 11.6095 14.2559 11.3811 14.5313 11.3811H24.9984C25.2738 11.3811 25.4992 11.6095 25.4992 11.8887C25.4992 12.1679 25.2738 12.3963 24.9984 12.3963Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45073 25.8731C1.57594 25.9493 1.75122 26 1.90147 26C2.05171 26 2.20196 25.9747 2.3522 25.8985L6.55905 23.4874C6.73434 23.3858 6.93467 23.3351 7.13499 23.3351H18.203C19.5944 23.3351 20.7795 22.4854 21.3004 21.2813C21.4337 20.973 21.1833 20.6597 20.8474 20.6597C20.6194 20.6597 20.4225 20.8098 20.3191 21.013C19.9222 21.7932 19.1183 22.3199 18.203 22.3199H7.13499C6.75938 22.3199 6.38377 22.4214 6.05824 22.599L2.00163 24.9087V12.7768C2.00163 12.7316 2.00286 12.6867 2.0053 12.6421V10.3527C1.38355 10.9696 1 11.8278 1 12.7768V25.0863C1 25.4163 1.17529 25.7208 1.45073 25.8731Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.9ac9aae6.svg";
export { ForwardRef as ReactComponent };